import React from "react";
import { Subscription } from "rxjs";
import ConfigProps from "../../constants/configProps";
import NavigationTokens from "../../constants/navigationTokens";
import ConfigPropService from "../../utilities/configPropService";
import MenuItemService from "../../utilities/menuItemService";
import NavigationTokensService from "../../utilities/navigationTokensService";
import YourRepresentative, {
  RepTypes,
} from "../yourRepresentative/yourRepresentative";
import MenuItem from "./menuItem";
import MenuItemDivider from "./menuItemDivider";
import { WBMUrlService } from "@wbmason/url-service";
import EnvironmentService from "../../utilities/environmentService";
import { BaseHostUrlService } from "../../utilities/baseHostUrlService";

export interface IOrdersMenuProps {}

export interface IOrdersMenuState {
  dashboardHref: string;
  orderHistoryHref: string;
  quickOrderHref: string;
  myWbRecentItemsHref: string;
  myWbRecentlyViewedHref: string;
  returnCenterHref: string;
  displayReturnsCenter: boolean;
  savedCartsHref: string;
  contactUsHref: string;
  displayRecentlyViewed: boolean;
  displayEasyReorder: boolean;
  displayDashboard: boolean;
  displayOrders: boolean;
  displaySavedCarts: boolean;
  displayQuickOrderLinks: boolean;
  shopUrl: string;
  quickOrderUrl: string;
}

class OrdersMenu extends React.Component<IOrdersMenuProps, IOrdersMenuState> {
  subsToUnsubscribe: Subscription[] = [];

  constructor(props: IOrdersMenuProps) {
    super(props);

    this.state = {
      dashboardHref: "",
      orderHistoryHref: "",
      quickOrderHref: "",
      myWbRecentlyViewedHref: "",
      myWbRecentItemsHref: "",
      returnCenterHref: "",
      savedCartsHref: "",
      contactUsHref: "",
      displayReturnsCenter: false,
      displayRecentlyViewed: false,
      displayEasyReorder: false,
      displayDashboard: false,
      displayOrders: false,
      displaySavedCarts: false,
      displayQuickOrderLinks: false,
      shopUrl: WBMUrlService.getShopUrl(
        BaseHostUrlService.get(),
        EnvironmentService.get().ecomSearch!
      ),
      quickOrderUrl: WBMUrlService.getQuickOrderUrl(
        BaseHostUrlService.get(),
        EnvironmentService.get().ecomQuickOrder!
      ),
    };
  }

  componentDidMount() {
    this.subsToUnsubscribe.push(
      NavigationTokensService.get([
        NavigationTokens.dashboard,
        NavigationTokens.orderHistory,
        NavigationTokens.quickOrder,
        NavigationTokens.myWbRecentItems,
        NavigationTokens.returnCenter,
        NavigationTokens.savedCarts,
        NavigationTokens.contactUs,
      ]).subscribe((navTokens) => {
        this.setState({
          dashboardHref: navTokens[NavigationTokens.dashboard],
          orderHistoryHref: navTokens[NavigationTokens.orderHistory],
          returnCenterHref: navTokens[NavigationTokens.returnCenter],
          savedCartsHref: navTokens[NavigationTokens.savedCarts],
          contactUsHref: navTokens[NavigationTokens.contactUs],
        });

        let myWbRecentItemsHrefEcom = navTokens[
          NavigationTokens.myWbRecentItems
        ]
          .toLowerCase()
          .replace(
            `${NavigationTokens.myWbRecentItems.toLowerCase()}.aspx`,
            "mobileapp/#/myWBRecentItems/PricePlan=UserOrdered&fi=1&fr=1&sc=OF"
          );

        let myWbRecentlyViewedHrefEcom = navTokens[
          NavigationTokens.myWbRecentItems
        ]
          .toLowerCase()
          .replace(
            `${NavigationTokens.myWbRecentItems.toLowerCase()}.aspx`,
            "mobileapp/#/myWBRecentItems/PricePlan=UserViewed&fi=1&fr=1&sc=OF"
          );

        let quickOrderHrefEcom = navTokens[NavigationTokens.quickOrder]
          .toLowerCase()
          .replace(
            `${NavigationTokens.quickOrder.toLowerCase()}.aspx`,
            "mobileapp/#/quickOrder"
          );

        this.subsToUnsubscribe.push(
          ConfigPropService.get([
            ConfigProps.EnableResponsiveSearchResults,
            ConfigProps.EnableResponsiveShopByItemNumber,
          ]).subscribe((configProps: Record<string, string>) => {
            this.setState({
              myWbRecentItemsHref: ConfigPropService.isYesOrTrue(
                configProps[ConfigProps.EnableResponsiveSearchResults]
              )
                ? `${this.state.shopUrl}?fi=1&fr=1&oa=1&priceplan=userordered&sc=or`
                : myWbRecentItemsHrefEcom,
              myWbRecentlyViewedHref: ConfigPropService.isYesOrTrue(
                configProps[ConfigProps.EnableResponsiveSearchResults]
              )
                ? `${this.state.shopUrl}?priceplan=userviewed&rvi=1`
                : myWbRecentlyViewedHrefEcom,
              quickOrderHref: ConfigPropService.isYesOrTrue(
                configProps[ConfigProps.EnableResponsiveShopByItemNumber]
              )
                ? this.state.quickOrderUrl
                : quickOrderHrefEcom,
            });
          })
        );
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayReturnsCenter().subscribe((value) => {
        this.setState({
          displayReturnsCenter: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayRecentlyViewed().subscribe((value) => {
        this.setState({
          displayRecentlyViewed: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayEasyReorder().subscribe((value) => {
        this.setState({
          displayEasyReorder: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayDashboard().subscribe((value) => {
        this.setState({
          displayDashboard: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayOrders().subscribe((value) => {
        this.setState({
          displayOrders: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displaySavedCarts().subscribe((value) => {
        this.setState({
          displaySavedCarts: value,
        });
      })
    );

    this.subsToUnsubscribe.push(
      MenuItemService.displayQuickOrderLinks().subscribe((value) => {
        this.setState({
          displayQuickOrderLinks: value,
        });
      })
    );
  }

  componentWillUnmount() {
    for (const sub of this.subsToUnsubscribe) {
      sub.unsubscribe();
    }
  }

  render() {
    return (
      <>
        {this.state.displayDashboard && (
          <MenuItem
            icon="dashboard"
            label="Dashboard"
            href={this.state.dashboardHref}
          />
        )}

        {this.state.displayOrders && (
          <MenuItem
            icon="history"
            label="Orders"
            href={this.state.orderHistoryHref}
          />
        )}

        {(this.state.displayDashboard || this.state.displayOrders) && (
          <MenuItemDivider />
        )}

        {this.state.displayQuickOrderLinks && (
          <MenuItem
            icon="menu_book"
            label="Shop By Item Number"
            href={this.state.quickOrderHref}
          />
        )}

        {this.state.displayEasyReorder && (
          <MenuItem
            icon="replay"
            label="Order Again"
            href={this.state.myWbRecentItemsHref}
          />
        )}

        {this.state.displayRecentlyViewed && (
          <MenuItem
            icon="schedule"
            label="Recently Viewed"
            href={this.state.myWbRecentlyViewedHref}
          />
        )}

        {this.state.displayReturnsCenter && (
          <MenuItem
            svg={() => {
              return (
                <img
                  src={process.env.PUBLIC_URL + "/images/returns_icon-24px.svg"}
                  alt="Returns Center"
                  width="24"
                  height="24"
                  style={{ width: 20, height: 20 }}
                />
              );
            }}
            label="Returns Center"
            href={this.state.returnCenterHref}
          />
        )}

        {this.state.displaySavedCarts && (
          <MenuItem
            svg={() => {
              return (
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/saved_shopping_cart_icon-24px.svg"
                  }
                  alt="Saved Carts"
                  width="24"
                  height="24"
                  style={{ width: 20, height: 20 }}
                />
              );
            }}
            label="Saved Carts"
            href={this.state.savedCartsHref}
          />
        )}

        <MenuItemDivider />

        <MenuItem
          label="Customer Support"
          icon="contact_support"
          href={this.state.contactUsHref}
        />

        <YourRepresentative repType={RepTypes.customerService} />
      </>
    );
  }
}

export default OrdersMenu;
